import React, { useState } from 'react'
import { motion } from 'framer-motion';
import { transition1 } from '../transitions';
import Loading from '../components/Loading';
import { useNavigate } from 'react-router-dom';

import photo1 from '../img/projects/WeightofWaters/wow1.JPG'
import photo2 from '../img/projects/WeightofWaters/wow2.JPG';
import photo3 from '../img/projects/WeightofWaters/wow3.JPG';
import photo4 from '../img/projects/WeightofWaters/wow4.JPG';
import photo5 from '../img/projects/WeightofWaters/wow5.JPG';
import photo6 from '../img/projects/WeightofWaters/wow6.JPG';
import photo7 from '../img/projects/WeightofWaters/wow7.JPG';
import photo8 from '../img/projects/WeightofWaters/wow8.JPG';
import photo9 from '../img/projects/WeightofWaters/wow9.JPG';
import photo10 from '../img/projects/WeightofWaters/wow10.JPG';
import photo11 from '../img/projects/WeightofWaters/wow11.JPG';





const Works = () => {

    const navigate = useNavigate()
 
  // Store works as objects with tags and src
  const allWorks = [
    {
      src: photo1, 
      tags: ["WeCollective", "Vertical"]
    },
    {
      src: photo2, 
      tags: ["WeCollective", "Vertical"]
    },
    
    
    {
      src: photo3, 
      tags: ["WeCollective", "Vertical"]
    },
    {
      src: photo4, 
      tags: ["WeCollective", "Vertical"]
    },
    {
      src: photo5, 
      tags: ["WeCollective", "Vertical"]
    },
    {
      src: photo6, 
      tags: ["WeCollective", "Vertical"]
    },
    {
      src: photo7, 
      tags: ["WeCollective", "Vertical"]
    },
    {
      src: photo8, 
      tags: ["WeCollective", "Vertical"]
    },
    {
      src: photo9, 
      tags: ["WeCollective", "Vertical"]
    },
    {
      src: photo10, 
      tags: ["WeCollective", "Vertical"]
    },
    {
      src: photo11, 
      tags: ["WeCollective", "Vertical"]
    },
  ];

  const [works, setWorks] = useState(allWorks);
  const [filterWork, setFilterWork] = useState(allWorks);
  const [directionFiltered, setDirectionFiltered] = useState(allWorks);
  const [activeDirection, setActiveDirection] = useState('Both');
  const [activeFilter, setActiveFilter] = useState('All');
  const [currentPage, setCurrentPage] = useState(1);
  const postsPerPage = 12;

  const handleWorkFilter = (category) => {
    setActiveFilter(category);
    setCurrentPage(1);

    setTimeout(() => {
      let filtered = category === 'All' ? works : works.filter(work => work.tags.includes(category));
      setFilterWork(filtered);

      // Apply direction filter again on new results
      if (activeDirection === 'Both') {
        setDirectionFiltered(filtered);
      } else {
        setDirectionFiltered(filtered.filter(work => work.tags.includes(activeDirection)));
      }
    }, 300);
  };

  const handleDirection = (dir) => {
    setActiveDirection(dir);
    setCurrentPage(1);

    setTimeout(() => {
      if (dir === 'Both') {
        setDirectionFiltered(filterWork);
      } else {
        setDirectionFiltered(filterWork.filter(work => work.tags.includes(dir)));
      }
    }, 300);
  };

  const indexOfLastPost = currentPage * postsPerPage;
  const indexOfFirstPost = indexOfLastPost - postsPerPage;
  const currentPosts = directionFiltered.slice(indexOfFirstPost, indexOfLastPost);
  const paginate = (number) => setCurrentPage(number);

  if (!works || works.length === 0) return <h1 className='h1'><Loading /></h1>;

  return (
    <motion.section
      initial={{ opacity: 0, y: '100%' }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: '100%' }}
      transition={transition1}
      className='lg:pt-32 overflow-auto pt-32 mb-44 lg:mb-0'
    >
      <div className=' container mx-auto h-full relative'>
        <div>
          {/* Filters */}
          {/* <div className='flex flex-col lg:items-center justify-center lg:mt-20 lg:flex-row h-full mt-2 items-center justify-start gap-x-24 text-center pt-24 pb-8'>
            <div className='flex items-center justify-between text-gray-400 w-3/4 rounded-md bg-zinc-900'>
              {categories.map((category) => (
                <div className='flex flex-col p-2 lg:px-10 lg:py-4' key={category}>
                  <button
                    className={`h1 text-lg hover:scale-110 ${activeFilter === category ? 'text-yellow-white' : ''}`}
                    onClick={() => handleWorkFilter(category)}
                  >
                    {category}
                  </button>
                </div>
              ))}
            </div>

            <div className='hidden lg:flex flex-row h-full gap-x-4 items-center mt-4 lg:mt-0 justify-start'>
              <GiVerticalFlip
                className={`bg-yellow-400 rounded-full hover:scale-110 cursor-pointer h1 p-1 text-4xl ${activeDirection === "Vertical" ? 'text-white' : ''}`}
                onClick={() => handleDirection("Vertical")}
              />
              <GiHorizontalFlip
                className={`bg-yellow-400 rounded-full hover:scale-110 cursor-pointer h1 p-1 text-4xl ${activeDirection === "Horizontal" ? 'text-white' : ''}`}
                onClick={() => handleDirection("Horizontal")}
              />
              <h1
                className={`bg-yellow-400 rounded-full h1 hover:scale-110 cursor-pointer p-1 text-2xl ${activeDirection === "Both" ? 'text-white' : ''}`}
                onClick={() => handleDirection("Both")}
              >
                Both
              </h1>
            </div> 
          </div> */}
        </div>

        <div className='w-full flex items-center justify-center'>
        <div
        onClick={() => navigate("/album")}
            className=" border-2 text-center mb-10 lg:mb-0 justify-center self-center border-black hover:scale-110 hover:bg-zinc-900 hover:text-white w-fit p-4 hover:cursor-pointer"
            >
        
         Back to Gallery
        </div>
        </div>
      
        {/* Grid of images */}
        {/* <h1 className='h2'>Album</h1> */}
        <div className='grid grid-cols-2 lg:pt-10 lg:grid-cols-3'>
            
          {currentPosts.map((work, index) => (
            <div key={index} className='flex w-4/5 ml-5 lg:max-w-[340px] lg:mb-14 mb-10 cursor-pointer'>
              <img
                onClick={() => window.open(work.src)}
                className='object-cover h-full w-full hover:scale-110 transition-all duration-500'
                src={work.src}
                alt={`work-${index}`}
              />
            </div>
          ))}
        </div>

        {/* <Pagination
          postsPerPage={postsPerPage}
          totalPosts={directionFiltered.length}
          paginate={paginate}
          currentPage={currentPage}
        /> */}
      </div>
    </motion.section>
  )
}

export default Works;
